import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { applyLevels } from '../shared/level.utils';

/** Carga la escala de niveles definida en la consola y la aplica a toda la app. */
@Injectable({ providedIn: 'root' })
export class LevelsService {
  private readonly version = new BehaviorSubject(0);
  /** Cambia cada vez que se aplica una escala nueva (para pantallas que guardan una copia). */
  readonly version$ = this.version.asObservable();

  constructor(private readonly http: HttpClient) {}

  async load(): Promise<void> {
    try {
      const res = await firstValueFrom(
        this.http.get<{ levels: { name: string; icon: string; threshold: number; description?: string }[] }>(
          `${environment.apiUrl}/points/levels`
        )
      );
      applyLevels(res?.levels ?? []);
      this.version.next(this.version.value + 1);
    } catch {
      // sin red: se queda con la escala de fabrica
    }
  }
}
